import { render } from "./StockForm.vue?vue&type=template&id=88e69a3c&scoped=true"
import script from "./StockForm.vue?vue&type=script&lang=js"
export * from "./StockForm.vue?vue&type=script&lang=js"

import "./StockForm.vue?vue&type=style&index=0&id=88e69a3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e69a3c"]])

export default __exports__